'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import MarkdownIt from 'markdown-it';
import { preprocessMarkdownBlock } from '../utils/MarkdownUtils';
export default class Markdown extends Component {
  constructor(props) {
    super(props);
    this.md = new MarkdownIt({
      html: this.props.html,
      breaks: this.props.breaks
    });
  }

  renderInlineMarkdown() {
    return this.md.renderInline(this.props.children);
  }

  renderMarkdown() {
    let preprocessed;

    try {
      preprocessed = preprocessMarkdownBlock(this.props.children);
    } catch (e) {
      preprocessed = this.props.children;
    }

    return this.md.render(preprocessed);
  }

  render() {
    const {
      breakWord,
      inline
    } = this.props;
    return /*#__PURE__*/_jsx("span", {
      className: 'markdown' + (!breakWord ? " hyphens-none" : ""),
      dangerouslySetInnerHTML: {
        __html: inline ? this.renderInlineMarkdown() : this.renderMarkdown()
      },
      style: this.props.style
    });
  }

}
Markdown.propTypes = {
  breaks: PropTypes.bool,
  breakWord: PropTypes.bool,
  children: PropTypes.node.isRequired,
  html: PropTypes.bool,
  inline: PropTypes.bool,
  style: PropTypes.object
};
Markdown.defaultProps = {
  breaks: true,
  breakWord: true,
  html: true,
  inline: false
};